/* src/app/shared/components/default-chart-styles.css */
:host ::ng-deep .highcharts-container {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  text-align: left;
  line-height: normal;
  z-index: 0;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  font-family:
    "Lucida Grande",
    "Lucida Sans Unicode",
    Arial,
    Helvetica,
    sans-serif;
  font-size: 12px;
  -webkit-user-select: none;
  user-select: none;
  touch-action: manipulation;
  outline: none;
}
:host ::ng-deep .highcharts-root {
  display: block;
}
:host ::ng-deep .highcharts-root text {
  stroke-width: 0;
}
:host ::ng-deep .highcharts-strong {
  font-weight: bold;
}
:host ::ng-deep .highcharts-emphasized {
  font-style: italic;
}
:host ::ng-deep .highcharts-anchor {
  cursor: pointer;
}
:host ::ng-deep .highcharts-background {
  fill: #ffffff;
}
:host ::ng-deep .highcharts-plot-border,
:host ::ng-deep .highcharts-plot-background {
  fill: none;
}
:host ::ng-deep .highcharts-label-box {
  fill: none;
}
:host ::ng-deep .highcharts-button-box {
  fill: inherit;
}
:host ::ng-deep .highcharts-tracker-line {
  stroke-linejoin: round;
  stroke: rgba(192, 192, 192, 0.0001);
  stroke-width: 22;
  fill: none;
}
:host ::ng-deep .highcharts-tracker-area {
  fill: rgba(192, 192, 192, 0.0001);
  stroke-width: 0;
}
:host ::ng-deep .highcharts-title {
  fill: #333333;
  font-size: 1.5em;
}
:host ::ng-deep .highcharts-subtitle {
  fill: #666666;
  font-size: 1em;
}
:host ::ng-deep .highcharts-axis-line {
  fill: none;
  stroke: #ccd6eb;
}
:host ::ng-deep .highcharts-yaxis .highcharts-axis-line {
  stroke-width: 0;
}
:host ::ng-deep .highcharts-axis-title {
  fill: #666666;
}
:host ::ng-deep .highcharts-axis-labels {
  fill: #666666;
  cursor: default;
  font-size: 0.9em;
}
:host ::ng-deep .highcharts-grid-line {
  fill: none;
  stroke: #e6e6e6;
}
:host ::ng-deep .highcharts-xaxis-grid .highcharts-grid-line {
  stroke-width: 0px;
}
:host ::ng-deep .highcharts-tick {
  stroke: #ccd6eb;
}
:host ::ng-deep .highcharts-yaxis .highcharts-tick {
  stroke-width: 0;
}
:host ::ng-deep .highcharts-minor-grid-line {
  stroke: #f2f2f2;
}
:host ::ng-deep .highcharts-crosshair-thin {
  stroke-width: 1px;
  stroke: #cccccc;
}
:host ::ng-deep .highcharts-crosshair-category {
  stroke: #ccd6eb;
  stroke-opacity: 0.25;
}
:host ::ng-deep .highcharts-credits {
  cursor: pointer;
  fill: #999999;
  font-size: 0.7em;
  transition: fill 250ms, font-size 250ms;
}
:host ::ng-deep .highcharts-credits:hover {
  fill: black;
  font-size: 1em;
}
:host ::ng-deep .highcharts-tooltip {
  cursor: default;
  pointer-events: none;
  white-space: nowrap;
  transition: stroke 150ms;
}
:host ::ng-deep .highcharts-tooltip text {
  fill: #333333;
}
:host ::ng-deep .highcharts-tooltip .highcharts-header {
  font-size: 0.85em;
}
:host ::ng-deep .highcharts-tooltip-box {
  stroke-width: 1px;
  fill: #f7f7f7;
  fill-opacity: 0.85;
}
:host ::ng-deep .highcharts-tooltip-box .highcharts-label-box {
  fill: #f7f7f7;
  fill-opacity: 0.85;
}
:host ::ng-deep div.highcharts-tooltip {
  filter: none;
}
:host ::ng-deep .highcharts-selection-marker {
  fill: #335cad;
  fill-opacity: 0.25;
}
:host ::ng-deep .highcharts-graph {
  fill: none;
  stroke-width: 2px;
  stroke-linecap: round;
  stroke-linejoin: round;
}
:host ::ng-deep .highcharts-empty-series {
  stroke-width: 1px;
  fill: none;
  stroke: #cccccc;
}
:host ::ng-deep .highcharts-state-hover :host ::ng-deep .highcharts-graph {
  stroke-width: 3;
}
:host ::ng-deep .highcharts-point-inactive {
  opacity: 0.2;
  transition: opacity 50ms;
}
:host ::ng-deep .highcharts-series-inactive {
  opacity: 0.2;
  transition: opacity 50ms;
}
:host ::ng-deep .highcharts-state-hover path {
  transition: stroke-width 50ms;
}
:host ::ng-deep .highcharts-state-normal path {
  transition: stroke-width 250ms;
}
:host ::ng-deep g.highcharts-series,
:host ::ng-deep .highcharts-point,
:host ::ng-deep .highcharts-markers,
:host ::ng-deep .highcharts-data-labels {
  transition: opacity 250ms;
}
:host ::ng-deep .highcharts-legend-series-active g.highcharts-series:not(.highcharts-series-hover),
:host ::ng-deep .highcharts-legend-point-active .highcharts-point:not(.highcharts-point-hover),
:host ::ng-deep .highcharts-legend-series-active .highcharts-markers:not(.highcharts-series-hover),
:host ::ng-deep .highcharts-legend-series-active .highcharts-data-labels:not(.highcharts-series-hover) {
  opacity: 0.2;
}
:host ::ng-deep .highcharts-color-0 {
  fill: #7cb5ec;
  stroke: #7cb5ec;
}
:host ::ng-deep .highcharts-color-1 {
  fill: #434348;
  stroke: #434348;
}
:host ::ng-deep .highcharts-color-2 {
  fill: #90ed7d;
  stroke: #90ed7d;
}
:host ::ng-deep .highcharts-color-3 {
  fill: #f7a35c;
  stroke: #f7a35c;
}
:host ::ng-deep .highcharts-color-4 {
  fill: #8085e9;
  stroke: #8085e9;
}
:host ::ng-deep .highcharts-color-5 {
  fill: #f15c80;
  stroke: #f15c80;
}
:host ::ng-deep .highcharts-color-6 {
  fill: #e4d354;
  stroke: #e4d354;
}
:host ::ng-deep .highcharts-color-7 {
  fill: #2b908f;
  stroke: #2b908f;
}
:host ::ng-deep .highcharts-color-8 {
  fill: #f45b5b;
  stroke: #f45b5b;
}
:host ::ng-deep .highcharts-color-9 {
  fill: #91e8e1;
  stroke: #91e8e1;
}
:host ::ng-deep .highcharts-area {
  fill-opacity: 0.75;
  stroke-width: 0;
}
:host ::ng-deep .highcharts-markers {
  stroke-width: 1px;
  stroke: #ffffff;
}
:host ::ng-deep .highcharts-a11y-markers-hidden .highcharts-point:not(.highcharts-point-hover):not(.highcharts-a11y-marker-visible),
:host ::ng-deep .highcharts-a11y-marker-hidden {
  opacity: 0;
}
:host ::ng-deep .highcharts-point {
  stroke-width: 1px;
}
:host ::ng-deep .highcharts-dense-data .highcharts-point {
  stroke-width: 0;
}
:host ::ng-deep .highcharts-data-label {
  font-size: 0.9em;
  font-weight: bold;
}
:host ::ng-deep .highcharts-data-label-box {
  fill: none;
  stroke-width: 0;
}
:host ::ng-deep .highcharts-data-label text,
:host ::ng-deep text.highcharts-data-label {
  fill: #333333;
}
:host ::ng-deep .highcharts-data-label-connector {
  fill: none;
}
:host ::ng-deep .highcharts-data-label-hidden {
  pointer-events: none;
}
:host ::ng-deep .highcharts-halo {
  fill-opacity: 0.25;
  stroke-width: 0;
}
:host ::ng-deep .highcharts-series:not(.highcharts-pie-series) .highcharts-point-select,
:host ::ng-deep .highcharts-markers .highcharts-point-select {
  fill: #cccccc;
  stroke: #000000;
}
:host ::ng-deep .highcharts-column-series rect.highcharts-point {
  stroke: #ffffff;
}
:host ::ng-deep .highcharts-column-series .highcharts-point {
  transition: fill-opacity 250ms;
}
:host ::ng-deep .highcharts-column-series .highcharts-point-hover {
  fill-opacity: 0.75;
  transition: fill-opacity 50ms;
}
:host ::ng-deep .highcharts-pie-series .highcharts-point {
  stroke-linejoin: round;
  stroke: #ffffff;
}
:host ::ng-deep .highcharts-pie-series .highcharts-point-hover {
  fill-opacity: 0.75;
  transition: fill-opacity 50ms;
}
:host ::ng-deep .highcharts-funnel-series .highcharts-point {
  stroke-linejoin: round;
  stroke: #ffffff;
}
:host ::ng-deep .highcharts-funnel-series .highcharts-point-hover {
  fill-opacity: 0.75;
  transition: fill-opacity 50ms;
}
:host ::ng-deep .highcharts-funnel-series .highcharts-point-select {
  fill: inherit;
  stroke: inherit;
}
:host ::ng-deep .highcharts-pyramid-series .highcharts-point {
  stroke-linejoin: round;
  stroke: #ffffff;
}
:host ::ng-deep .highcharts-pyramid-series .highcharts-point-hover {
  fill-opacity: 0.75;
  transition: fill-opacity 50ms;
}
:host ::ng-deep .highcharts-pyramid-series .highcharts-point-select {
  fill: inherit;
  stroke: inherit;
}
:host ::ng-deep .highcharts-solidgauge-series .highcharts-point {
  stroke-width: 0;
}
:host ::ng-deep .highcharts-treemap-series .highcharts-point {
  stroke-width: 1px;
  stroke: #e6e6e6;
  transition:
    stroke 250ms,
    fill 250ms,
    fill-opacity 250ms;
}
:host ::ng-deep .highcharts-treemap-series .highcharts-point-hover {
  stroke: #999999;
  transition:
    stroke 25ms,
    fill 25ms,
    fill-opacity 25ms;
}
:host ::ng-deep .highcharts-treemap-series .highcharts-above-level {
  display: none;
}
:host ::ng-deep .highcharts-treemap-series .highcharts-internal-node {
  fill: none;
}
:host ::ng-deep .highcharts-treemap-series .highcharts-internal-node-interactive {
  fill-opacity: 0.15;
  cursor: pointer;
}
:host ::ng-deep .highcharts-treemap-series .highcharts-internal-node-interactive:hover {
  fill-opacity: 0.75;
}
:host ::ng-deep .highcharts-vector-series .highcharts-point {
  fill: none;
  stroke-width: 2px;
}
:host ::ng-deep .highcharts-windbarb-series .highcharts-point {
  fill: none;
  stroke-width: 2px;
}
:host ::ng-deep .highcharts-lollipop-stem {
  stroke: #000000;
}
:host ::ng-deep .highcharts-focus-border {
  fill: none;
  stroke-width: 2px;
}
:host ::ng-deep .highcharts-legend-item-hidden .highcharts-focus-border {
  fill: none !important;
}
:host ::ng-deep .highcharts-legend-box {
  fill: none;
  stroke-width: 0;
}
:host ::ng-deep .highcharts-legend-item > text {
  fill: #333333;
  font-weight: bold;
  font-size: 1em;
  cursor: pointer;
  stroke-width: 0;
}
:host ::ng-deep .highcharts-legend-item:hover text {
  fill: #000000;
}
:host ::ng-deep .highcharts-legend-item-hidden * {
  fill: #cccccc !important;
  stroke: #cccccc !important;
  transition: fill 250ms;
}
:host ::ng-deep .highcharts-legend-nav-active {
  fill: #003399;
  cursor: pointer;
}
:host ::ng-deep .highcharts-legend-nav-inactive {
  fill: #cccccc;
}
:host ::ng-deep circle.highcharts-legend-nav-active,
:host ::ng-deep circle.highcharts-legend-nav-inactive {
  fill: rgba(192, 192, 192, 0.0001);
}
:host ::ng-deep .highcharts-legend-title-box {
  fill: none;
  stroke-width: 0;
}
:host ::ng-deep .highcharts-bubble-legend-symbol {
  stroke-width: 2;
  fill-opacity: 0.5;
}
:host ::ng-deep .highcharts-bubble-legend-connectors {
  stroke-width: 1;
}
:host ::ng-deep .highcharts-bubble-legend-labels {
  fill: #333333;
}
:host ::ng-deep .highcharts-loading {
  position: absolute;
  background-color: #ffffff;
  opacity: 0.5;
  text-align: center;
  z-index: 10;
  transition: opacity 250ms;
}
:host ::ng-deep .highcharts-loading-hidden {
  height: 0 !important;
  opacity: 0;
  overflow: hidden;
  transition: opacity 250ms, height 250ms step-end;
}
:host ::ng-deep .highcharts-loading-inner {
  font-weight: bold;
  position: relative;
  top: 45%;
}
:host ::ng-deep .highcharts-plot-band,
:host ::ng-deep .highcharts-pane {
  fill: #000000;
  fill-opacity: 0.05;
}
:host ::ng-deep .highcharts-plot-line {
  fill: none;
  stroke: #999999;
  stroke-width: 1px;
}
:host ::ng-deep .highcharts-boxplot-box {
  fill: #ffffff;
}
:host ::ng-deep .highcharts-boxplot-median {
  stroke-width: 2px;
}
:host ::ng-deep .highcharts-bubble-series .highcharts-point {
  fill-opacity: 0.5;
}
:host ::ng-deep .highcharts-errorbar-series .highcharts-point {
  stroke: #000000;
}
:host ::ng-deep .highcharts-gauge-series .highcharts-data-label-box {
  stroke: #cccccc;
  stroke-width: 1px;
}
:host ::ng-deep .highcharts-gauge-series .highcharts-dial {
  fill: #000000;
  stroke-width: 0;
}
:host ::ng-deep .highcharts-polygon-series .highcharts-graph {
  fill: inherit;
  stroke-width: 0;
}
:host ::ng-deep .highcharts-waterfall-series .highcharts-graph {
  stroke: #333333;
  stroke-dasharray: 1, 3;
}
:host ::ng-deep .highcharts-sankey-series .highcharts-point {
  stroke-width: 0;
}
:host ::ng-deep .highcharts-sankey-series .highcharts-link {
  transition: fill 250ms, fill-opacity 250ms;
  fill-opacity: 0.5;
}
:host ::ng-deep .highcharts-sankey-series .highcharts-point-hover.highcharts-link {
  transition: fill 50ms, fill-opacity 50ms;
  fill-opacity: 1;
}
:host ::ng-deep .highcharts-venn-series .highcharts-point {
  fill-opacity: 0.75;
  stroke: #cccccc;
  transition: stroke 250ms, fill-opacity 250ms;
}
:host ::ng-deep .highcharts-venn-series .highcharts-point-hover {
  fill-opacity: 1;
  stroke: #cccccc;
}
:host ::ng-deep .highcharts-navigator-mask-outside {
  fill-opacity: 0;
}
:host ::ng-deep .highcharts-navigator-mask-inside {
  fill: #6685c2;
  fill-opacity: 0.25;
  cursor: ew-resize;
}
:host ::ng-deep .highcharts-navigator-outline {
  stroke: #cccccc;
  fill: none;
}
:host ::ng-deep .highcharts-navigator-handle {
  stroke: #cccccc;
  fill: #f2f2f2;
  cursor: ew-resize;
}
:host ::ng-deep .highcharts-navigator-series {
  fill: #335cad;
  stroke: #335cad;
}
:host ::ng-deep .highcharts-navigator-series .highcharts-graph {
  stroke-width: 1px;
}
:host ::ng-deep .highcharts-navigator-series .highcharts-area {
  fill-opacity: 0.05;
}
:host ::ng-deep .highcharts-navigator-xaxis .highcharts-axis-line {
  stroke-width: 0;
}
:host ::ng-deep .highcharts-navigator-xaxis .highcharts-grid-line {
  stroke-width: 1px;
  stroke: #e6e6e6;
}
:host ::ng-deep .highcharts-navigator-xaxis.highcharts-axis-labels {
  fill: #999999;
}
:host ::ng-deep .highcharts-navigator-yaxis .highcharts-grid-line {
  stroke-width: 0;
}
:host ::ng-deep .highcharts-scrollbar-thumb {
  fill: #cccccc;
  stroke: #cccccc;
  stroke-width: 1px;
}
:host ::ng-deep .highcharts-scrollbar-button {
  fill: #e6e6e6;
  stroke: #cccccc;
  stroke-width: 1px;
}
:host ::ng-deep .highcharts-scrollbar-arrow {
  fill: #666666;
}
:host ::ng-deep .highcharts-scrollbar-rifles {
  stroke: #666666;
  stroke-width: 1px;
}
:host ::ng-deep .highcharts-scrollbar-track {
  fill: #f2f2f2;
  stroke: #f2f2f2;
  stroke-width: 1px;
}
:host ::ng-deep .highcharts-button {
  fill: #f7f7f7;
  stroke: #cccccc;
  cursor: default;
  stroke-width: 1px;
  transition: fill 250ms;
}
:host ::ng-deep .highcharts-button text {
  fill: #333333;
}
:host ::ng-deep .highcharts-button-hover {
  transition: fill 0ms;
  fill: #e6e6e6;
  stroke: #cccccc;
}
:host ::ng-deep .highcharts-button-hover text {
  fill: #333333;
}
:host ::ng-deep .highcharts-button-pressed {
  font-weight: bold;
  fill: #e6ebf5;
  stroke: #cccccc;
}
:host ::ng-deep .highcharts-button-pressed text {
  fill: #333333;
  font-weight: bold;
}
:host ::ng-deep .highcharts-button-disabled text {
  fill: #333333;
}
:host ::ng-deep .highcharts-range-selector-buttons .highcharts-button {
  stroke-width: 0px;
}
:host ::ng-deep .highcharts-range-label rect {
  fill: none;
}
:host ::ng-deep .highcharts-range-label text {
  fill: #666666;
}
:host ::ng-deep .highcharts-range-input rect {
  fill: none;
}
:host ::ng-deep .highcharts-range-input text {
  fill: #333333;
}
:host ::ng-deep .highcharts-range-input {
  stroke-width: 1px;
  stroke: #cccccc;
}
:host ::ng-deep input.highcharts-range-selector {
  position: absolute;
  border: 0;
  width: 1px;
  height: 1px;
  padding: 0;
  text-align: center;
  left: -9em;
}
:host ::ng-deep .highcharts-crosshair-label text {
  fill: #ffffff;
  font-size: 1.1em;
}
:host ::ng-deep .highcharts-crosshair-label .highcharts-label-box {
  fill: inherit;
}
:host ::ng-deep .highcharts-candlestick-series .highcharts-point {
  stroke: #000000;
  stroke-width: 1px;
}
:host ::ng-deep .highcharts-candlestick-series .highcharts-point-up {
  fill: #ffffff;
}
:host ::ng-deep .highcharts-hollowcandlestick-series .highcharts-point-down {
  fill: #f21313;
  stroke: #f21313;
}
:host ::ng-deep .highcharts-hollowcandlestick-series .highcharts-point-down-bearish-up {
  fill: #06b535;
  stroke: #06b535;
}
:host ::ng-deep .highcharts-hollowcandlestick-series .highcharts-point-up {
  fill: transparent;
  stroke: #06b535;
}
:host ::ng-deep .highcharts-ohlc-series .highcharts-point-hover {
  stroke-width: 3px;
}
:host ::ng-deep .highcharts-flags-series .highcharts-point .highcharts-label-box {
  stroke: #999999;
  fill: #ffffff;
  transition: fill 250ms;
}
:host ::ng-deep .highcharts-flags-series .highcharts-point-hover .highcharts-label-box {
  stroke: #000000;
  fill: #ccd6eb;
}
:host ::ng-deep .highcharts-flags-series .highcharts-point text {
  fill: #000000;
  font-size: 0.9em;
  font-weight: bold;
}
:host ::ng-deep .highcharts-map-series .highcharts-point {
  transition:
    fill 500ms,
    fill-opacity 500ms,
    stroke-width 250ms;
  stroke: #cccccc;
  stroke-width: inherit;
}
:host ::ng-deep .highcharts-map-series .highcharts-point-hover {
  transition: fill 0ms, fill-opacity 0ms;
  fill-opacity: 0.5;
}
:host ::ng-deep .highcharts-mapline-series .highcharts-point {
  fill: none;
}
:host ::ng-deep .highcharts-heatmap-series .highcharts-point {
  stroke-width: 0;
}
:host ::ng-deep .highcharts-map-navigation {
  font-size: 1.3em;
  font-weight: bold;
  text-align: center;
}
:host ::ng-deep .highcharts-mapview-inset-border {
  stroke: #cccccc;
  stroke-width: 1px;
  fill: none;
}
:host ::ng-deep .highcharts-coloraxis {
  stroke-width: 0;
}
:host ::ng-deep .highcharts-coloraxis-marker {
  fill: #999999;
}
:host ::ng-deep .highcharts-null-point {
  fill: #f7f7f7;
}
:host ::ng-deep .highcharts-3d-frame {
  fill: transparent;
}
:host ::ng-deep .highcharts-contextbutton {
  fill: #ffffff;
  stroke: none;
  stroke-linecap: round;
}
:host ::ng-deep .highcharts-contextbutton:hover {
  fill: #e6e6e6;
  stroke: #e6e6e6;
}
:host ::ng-deep .highcharts-button-symbol {
  stroke: #666666;
  stroke-width: 3px;
}
:host ::ng-deep .highcharts-menu {
  border: 1px solid #999999;
  background: #ffffff;
  padding: 5px 0;
  box-shadow: 3px 3px 10px #888;
}
:host ::ng-deep .highcharts-menu-item {
  padding: 0.5em 1em;
  background: none;
  color: #333333;
  cursor: pointer;
  transition: background 250ms, color 250ms;
}
:host ::ng-deep .highcharts-menu-item:hover {
  background: #335cad;
  color: #ffffff;
}
:host ::ng-deep .highcharts-breadcrumbs-button {
  fill: none;
  stroke-width: 0;
  cursor: pointer;
}
:host ::ng-deep .highcharts-breadcrumbs-separator {
  fill: #666666;
}
:host ::ng-deep .highcharts-drilldown-point {
  cursor: pointer;
}
:host ::ng-deep .highcharts-drilldown-data-label text,
:host ::ng-deep text.highcharts-drilldown-data-label,
:host ::ng-deep .highcharts-drilldown-axis-label {
  cursor: pointer;
  fill: #003399;
  font-weight: bold;
  text-decoration: underline;
}
:host ::ng-deep .highcharts-no-data text {
  font-weight: bold;
  font-size: 12px;
  fill: #666666;
}
:host ::ng-deep .highcharts-axis-resizer {
  cursor: ns-resize;
  stroke: black;
  stroke-width: 2px;
}
:host ::ng-deep .highcharts-bullet-target {
  stroke-width: 0;
}
:host ::ng-deep .highcharts-lineargauge-target {
  stroke-width: 1px;
  stroke: #333333;
}
:host ::ng-deep .highcharts-lineargauge-target-line {
  stroke-width: 1px;
  stroke: #333333;
}
:host ::ng-deep .highcharts-annotation-label-box {
  stroke-width: 1px;
  stroke: #000000;
  fill: #000000;
  fill-opacity: 0.75;
}
:host ::ng-deep .highcharts-annotation-label text {
  fill: #e6e6e6;
}
:host ::ng-deep .highcharts-a11y-proxy-button {
  border-width: 0;
  background-color: transparent;
  cursor: pointer;
  outline: none;
  opacity: 0.001;
  z-index: 999;
  overflow: hidden;
  padding: 0;
  margin: 0;
  display: block;
  position: absolute;
}
:host ::ng-deep .highcharts-a11y-proxy-group li {
  list-style: none;
}
:host ::ng-deep .highcharts-visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  white-space: nowrap;
  clip: rect(1px, 1px, 1px, 1px);
  margin-top: -3px;
  opacity: 0.01;
}
:host ::ng-deep .highcharts-a11y-invisible {
  visibility: hidden;
}
:host ::ng-deep .highcharts-a11y-proxy-container,
:host ::ng-deep .highcharts-a11y-proxy-container-before,
:host ::ng-deep .highcharts-a11y-proxy-container-after {
  position: absolute;
  white-space: nowrap;
}
:host ::ng-deep g.highcharts-series,
:host ::ng-deep .highcharts-markers,
:host ::ng-deep .highcharts-point {
  outline: none;
}
:host ::ng-deep .highcharts-treegrid-node-collapsed,
:host ::ng-deep .highcharts-treegrid-node-expanded {
  cursor: pointer;
}
:host ::ng-deep .highcharts-point-connecting-path {
  fill: none;
}
:host ::ng-deep .highcharts-grid-axis .highcharts-tick {
  stroke-width: 1px;
}
:host ::ng-deep .highcharts-grid-axis .highcharts-axis-line {
  stroke-width: 1px;
}

/* src/app/views/area-publica/detalhes-projeto/maturidade/spider-web-chart-public/spider-web-chart-public.component.scss */
:host ::ng-deep .highcharts-container {
  margin: 0 auto;
}
:host ::ng-deep .highcharts-graph {
  fill: transparent;
  stroke-width: 1px;
}
:host ::ng-deep .highcharts-text-outline {
  display: none;
}
:host ::ng-deep .highcharts-label {
  opacity: 1 !important;
}
:host ::ng-deep .highcharts-navigator-yaxis .highcharts-grid-line {
  stroke-width: 1px !important;
}
:host ::ng-deep .highcharts-axis-line {
  stroke: none;
}
:host ::ng-deep .highcharts-xaxis-grid .highcharts-grid-line {
  stroke-width: 1px;
}
:host ::ng-deep .amb_inv .highcharts-data-label-box {
  fill: #ffb380;
}
:host ::ng-deep .label-vertente-grafico-amb_inv {
  background-color: #ffb380;
}
:host ::ng-deep .prog_ac .highcharts-data-label-box {
  fill: #80bde0;
}
:host ::ng-deep .label-vertente-grafico-prog_ac {
  background-color: #80bde0;
}
:host ::ng-deep .icti .highcharts-data-label-box {
  fill: #284395;
}
:host ::ng-deep .label-vertente-grafico-icti {
  background-color: #284395;
}
:host ::ng-deep .pol_publ .highcharts-data-label-box {
  fill: #85f4bc;
}
:host ::ng-deep .label-vertente-grafico-pol_publ {
  background-color: #85f4bc;
}
:host ::ng-deep .cap .highcharts-data-label-box {
  fill: #ffabab;
}
:host ::ng-deep .label-vertente-grafico-cap {
  background-color: #ffabab;
}
:host ::ng-deep .gov .highcharts-data-label-box {
  fill: #f4465a;
}
:host ::ng-deep .label-vertente-grafico-gov {
  background-color: #f4465a;
}
:host ::ng-deep .highcharts-data-label text {
  fill: white;
}
:host ::ng-deep .container-label-vertente {
  width: 120px;
}
:host ::ng-deep .label-vertente {
  font-size: 14px;
  display: inline-block;
  width: 80%;
  margin-top: 0;
}
:host ::ng-deep .topic {
  content: "";
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 100%;
  margin-right: 8px;
  vertical-align: top;
  margin-top: 6px;
}
:host ::ng-deep .highcharts-container {
  position: relative;
  overflow: hidden;
  width: 620px;
  height: 600px;
  text-align: left;
  line-height: normal;
  z-index: 0;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-user-select: none;
  user-select: none;
  touch-action: manipulation;
  outline: none;
  margin: 0 auto;
}
:host ::ng-deep .highcharts-color-0 {
  fill: rgba(0, 0, 0, 0.1019607843);
  stroke: #AFAFAF;
}
:host ::ng-deep .highcharts-point {
  fill: #8f8f8f;
  stroke: #8f8f8f;
}
:host ::ng-deep .span-container-label-vertente-amb_inv {
  left: 202px !important;
}
:host ::ng-deep .span-container-label-vertente-pol_publ {
  left: 224px !important;
  top: 518.125px !important;
}
:host ::ng-deep .highcharts-grid-line {
  stroke: #8f8f8f;
}
/**
 * @license Highcharts
 *
 * (c) 2009-2016 Torstein Honsi
 *
 * License: www.highcharts.com/license
 */
/*# sourceMappingURL=spider-web-chart-public.component.css.map */
